import { Selection, ScaleLinear } from 'd3'
import { CultureIndexTraitSymbol } from '../../core/culture-index.model'

export type NodeSize = 'small' | 'normal' | 'large'

export type SvgNode = Selection<SVGSVGElement, unknown, null, undefined>
export type SvgScale = ScaleLinear<number, number>

export interface ICoreMarginConfig {
  top: number
  right: number
  bottom: number
  left: number
}
export interface ICoreConfig {
  gridWidth: number
  gridHeight: number
  margin: ICoreMarginConfig
}

export interface ISvgScales {
  xScale: SvgScale
  yScale: SvgScale
}

export interface IInnerDimensions {
  innerHeight: number
  innerWidth: number
}

export interface IDrawingAssets {
  nodes: INode[]
  connections: INodeInterConnection[]
}

export interface IDimensions {
  width: number
  height: number
}

export interface ExtraOptions {
  compare?: boolean
}

export interface FontConfig {
  fontSize: number
}

export interface INode {
  id: CultureIndexTraitSymbol
  x: number
  y: number
  radius: number
  size: NodeSize
  color: string
  borderColor: string
}

export interface INodeInterConnection {
  source: CultureIndexTraitSymbol
  target: CultureIndexTraitSymbol
  color?: string
  width?: number
  dashed?: boolean
}

export interface ISpecialConnection {
  position: number
  color?: string
  width?: number
  dashed?: boolean
  size?: number
}

export enum SVGComponents {
  NODE = 'nodes-group',
  LINKS = 'links-group',
  CLINE = 'cline-group',
}

export enum TraitDotsType {
  MAIN_DOTS = '',
  COMPARE_DOTS = 'compare-',
}
